import React, { useState } from "react";

const FamilyTree = () => {
  const [familyData, setFamilyData] = useState([
    { id: 1, name: "Karthick Raj (You)", relation: "Myself", parentId: null }
  ]);
  const [name, setName] = useState("");
  const [relation, setRelation] = useState("");
  const [parentId, setParentId] = useState(null);

  const addFamilyMember = () => {
    if (name && relation) {
      setFamilyData([...familyData, { id: familyData.length + 1, name, relation, parentId }]);
      setName("");
      setRelation("");
      setParentId(null);
    }
  };

  const getHierarchyLevel = (relation) => {
    const levels = {
      "Grandfather (Paternal)": -2, "Grandmother (Paternal)": -2,
      "Grandfather (Maternal)": -2, "Grandmother (Maternal)": -2,
      "Father": -1, "Mother": -1,
      "Uncle": -1, "Aunt": -1,
      "Myself": 0, "Wife": 0, "Husband": 0, "Brother": 0, "Sister": 0,
      "Son": 1, "Daughter": 1,
      "Grandson": 2, "Granddaughter": 2,
      "Nephew": 1, "Niece": 1,
      "Cousin": 0
    };
    return levels[relation] || 0;
  };

  const renderTree = (level) => {
    const members = familyData.filter(member => getHierarchyLevel(member.relation) === level);
    if (!members.length) return null;
    
    return (
      <div className="flex flex-col items-center relative">
        <div className="flex space-x-4 border-b border-gray-500 pb-4">
          {members.map(member => (
            <div key={member.id} className="flex flex-col items-center relative">
              <div className="w-16 h-16 bg-purple-500 rounded-full flex items-center justify-center text-white font-bold relative">
                {member.name[0]}
                {member.parentId !== null && (
                  <div className="absolute top-0 left-1/2 w-0.5 h-4 bg-gray-500 transform -translate-x-1/2"></div>
                )}
              </div>
              <div className="text-center text-sm">{member.name} ({member.relation})</div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-col items-center p-6 bg-gray-100 min-h-screen">
      <h1 className="text-3xl font-extrabold mb-6 text-purple-700">Family Tree</h1>
      <div className="mb-6 flex flex-col items-center">
        <input type="text" placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} className="border p-2 mb-2" />
        <select value={relation} onChange={(e) => setRelation(e.target.value)} className="border p-2 mb-2">
          <option value="">Select Relation</option>
          {[ 'Father', 'Mother', 'Brother', 'Sister', 'Wife', 'Husband', 'Grandfather (Paternal)', 'Grandmother (Paternal)', 'Grandfather (Maternal)', 'Grandmother (Maternal)', 'Son', 'Daughter', 'Grandson', 'Granddaughter', 'Uncle', 'Aunt', 'Cousin', 'Nephew', 'Niece' ].map(rel => <option key={rel} value={rel}>{rel}</option>)}
        </select>
        <select value={parentId} onChange={(e) => setParentId(Number(e.target.value) || null)} className="border p-2 mb-2">
          <option value="">Select Parent (Optional)</option>
          {familyData.map(member => <option key={member.id} value={member.id}>{member.name}</option>)}
        </select>
        <button onClick={addFamilyMember} className="bg-blue-500 text-white px-4 py-2 rounded">Add Member</button>
      </div>
      <div className="bg-white p-6 rounded shadow-lg flex flex-col items-center">
        {renderTree(-2)} {/* Grandparents */}
        {renderTree(-1)} {/* Parents, Uncles, Aunts */}
        {renderTree(0)} {/* You, Siblings, Spouse */}
        {renderTree(1)} {/* Children, Nephews, Nieces */}
        {renderTree(2)} {/* Grandchildren */}
      </div>
    </div>
  );
};

export default FamilyTree;
